import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.00004 11.6663C4.54171 11.6663 4.14935 11.5031 3.82296 11.1768C3.49657 10.8504 3.33337 10.458 3.33337 9.99967C3.33337 9.54134 3.49657 9.14898 3.82296 8.82259C4.14935 8.4962 4.54171 8.33301 5.00004 8.33301C5.45837 8.33301 5.85073 8.4962 6.17712 8.82259C6.50351 9.14898 6.66671 9.54134 6.66671 9.99967C6.66671 10.458 6.50351 10.8504 6.17712 11.1768C5.85073 11.5031 5.45837 11.6663 5.00004 11.6663ZM10 11.6663C9.54171 11.6663 9.14935 11.5031 8.82296 11.1768C8.49657 10.8504 8.33337 10.458 8.33337 9.99967C8.33337 9.54134 8.49657 9.14898 8.82296 8.82259C9.14935 8.4962 9.54171 8.33301 10 8.33301C10.4584 8.33301 10.8507 8.4962 11.1771 8.82259C11.5035 9.14898 11.6667 9.54134 11.6667 9.99967C11.6667 10.458 11.5035 10.8504 11.1771 11.1768C10.8507 11.5031 10.4584 11.6663 10 11.6663ZM15 11.6663C14.5417 11.6663 14.1493 11.5031 13.823 11.1768C13.4966 10.8504 13.3334 10.458 13.3334 9.99967C13.3334 9.54134 13.4966 9.14898 13.823 8.82259C14.1493 8.4962 14.5417 8.33301 15 8.33301C15.4584 8.33301 15.8507 8.4962 16.1771 8.82259C16.5035 9.14898 16.6667 9.54134 16.6667 9.99967C16.6667 10.458 16.5035 10.8504 16.1771 11.1768C15.8507 11.5031 15.4584 11.6663 15 11.6663Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgMoreHorizontal);
export { ForwardRef as ReactComponent };
